export enum TcFormlyWrapper {
  ExpansionPanel = 'expansion-panel',
  Panel = 'panel',
  GenericPanel = 'generic-panel',
  FormField = 'form-field',
  ClearInputSuffix = 'clear-input-suffix',
}
